import { useState } from "react";

const Deploy = ({ onClose }) => {
  const [open, setOpen] = useState(true); // start open by default

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose();
  };

  return (
    open && (
      <div className="help-div">
        <div className="help-wrapper">
          <div className="help-text">
            <h2 className="help-page-title">Deployment in Progress</h2>
            <p className="help-message">
              The deployment process has started. Please wait until it completes successfully.
            </p>

            <ul className="help-page-lists">
              <li>Building assets...</li>
              <li>Updating environment...</li>
              <li>Publishing changes...</li>
            </ul>

            <div className="clsbtngrp d-flex justify-content-end mt-3">
              <button className="btn-black" onClick={handleClose}>
                Understood
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default Deploy;
